const InvoiceStatusFormDefaultValue = (invoiceStatus: string | null, invoiceId: number | null) => {
  return {
    invoiceId,
    invoiceStatus,
    notes: ''
  };
};
export default InvoiceStatusFormDefaultValue;
